import {
  teamEventMarkersForMetricAtom,
  unwrappedTeamEventMarkersForMetricAtom,
} from '@/atoms/queries/team/teamEventData';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';
import { HeatMap } from '@/components/visualisations/HeatMap';
import { PitchVisComponentProps } from '@/types/visualisation';

export const TeamHeatMap = ({ allowInteraction }: PitchVisComponentProps) => (
  <MetricKeyFallbackWrapper>
    <HeatMap
      pitchEventsAtom={teamEventMarkersForMetricAtom}
      unwrappedPitchEventsAtom={unwrappedTeamEventMarkersForMetricAtom}
      allowInteraction={allowInteraction}
      swapCropUnderAgainst
    />
  </MetricKeyFallbackWrapper>
);
